/** @jsx jsx */

import React, {
  Fragment as _,
  useState,
  useContext,
  useMemo,
  useRef,
  useEffect,
  useLayoutEffect,
  ReactElement,
  createContext,
} from 'react';
import { css, jsx } from '@emotion/core';
import { DragDropContext } from 'react-beautiful-dnd';
import Feedback from './Feedback';
import LayoutResponsiveContainer from './LayoutResponsiveContainer';
import checkReturnToInteractionEditing from 'services/checkReturnToInteractionEditing';

const Layout = ({
  columns,
  onDragEnd,
  feedback,
  useMediaInFeedback,
  setFeedback,
  reset,
}) => {
  const [allPlaceHoldersResolved, setAllPlaceHoldersResolved] = useState<
    boolean
  >(false);
  //
  useEffect(() => {
    if (allPlaceHoldersResolved) {
      return;
    }

    const localAllPlaceHoldersResolved = columns.column_a.every((d, index) => {
      return d.key.includes('placeholder');
    });

    if (localAllPlaceHoldersResolved) {
      setAllPlaceHoldersResolved(true);
    }
  });

  return (
    <_>
      <div
        className={reset ? 'fader_-5s' : ''}
        css={css`
          position: relative;
          width: 100%;
        `}
      >
        <DragDropContext onDragEnd={onDragEnd}>
          <LayoutResponsiveContainer>
            <div
              id="matching-columns-a-container"
              css={css`
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                width: 100%;

                ${allPlaceHoldersResolved &&
                  `
                  width: 0px;
                  height: 0px;
                  overflow: hidden;

                  transition: all 0.2s;
                `}
              `}
            >
              {columns.column_a}
            </div>
            <div
              css={css`
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                width: 100%;
              `}
            >
              {columns.column_b}
            </div>
          </LayoutResponsiveContainer>
        </DragDropContext>

        {feedback && (
          <Feedback
            useMediaInFeedback={useMediaInFeedback}
            onClose={() => {
              window.dev() && checkReturnToInteractionEditing(true);

              //
              let drags: any = Array.from(
                document.querySelectorAll(
                  '#matching-columns-a-container > div'
                ) as any
              );

              drags = drags.filter(
                (drag: any) => !drag.className.includes('Placeholder')
              );

              if (drags.length) {
                const focusedDrag = drags[0]?.firstChild;
              }

              setFeedback(null);
            }}
          >
            {(feedback as any).props.children}
          </Feedback>
        )}
      </div>
    </_>
  );
};

export default Layout;
